export default __webpack_public_path__ + "static/media/zak.b85d5583.png";